import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const PaymentProtectionInsuranceSuccess = ({ confirmAction }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Button']);

  return (
    <Modal title={t('PaymentProtectionInsuranceSuccess.title')}>
      <p>{t('PaymentProtectionInsuranceSuccess.info')}</p>
      <ModalActions>
        <Button onClick={confirmAction}>{t('Button:clear')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default PaymentProtectionInsuranceSuccess;
